import { CollisionPriority } from '@dnd-kit/abstract';
import { useDroppable } from '@dnd-kit/react';
import { Box } from '@mui/material';

import Typography from '@/shared/ui/typography/Text';

import { BLANK_COLUMN_ID } from '../types';

/**
 * BlankColumn component - drop zone for creating new apps from tabs.
 * Shows visual feedback when a tab is being dragged over.
 */
export const BlankColumn = () => {
  const { ref, isDropTarget } = useDroppable({
    id: BLANK_COLUMN_ID,
    type: 'new-column',
    accept: ['item'],
    collisionPriority: CollisionPriority.Low
  });

  return (
    <Box
      ref={ref}
      sx={{
        position: 'relative',
        display: 'flex',
        backgroundColor: isDropTarget ? 'rgba(53, 72, 142, 0.25)' : 'gx.tileDark',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '40vh',
        border: '4px dashed',
        borderColor: isDropTarget ? 'gx.textDisabled' : 'transparent',
        transition: 'background-color 120ms ease, outline-color 120ms ease'
      }}
    >
      <Typography
        size={14}
        sx={{
          color: 'gx.textDisabled'
        }}
      >
        Drop a tab here
      </Typography>
    </Box>
  );
};

export default BlankColumn;
